module.exports = __webpack_public_path__ + "img/11.290e9a26.jpg";